import { Suspense, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { DockerImageInputFallback } from '@/components/form/docker-image-input/fallback'
import { RegistrySelector } from '@/components/form/docker-image-input/registry-selector'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import type { CreateAppFormValues } from '@/routes/apps/create-app/form/schema'

export const DockerImageInput = () => {
  const form = useFormContext<CreateAppFormValues>()
  const { resetField } = form

  useEffect(() => {
    return () => {
      resetField('dockerImage')
    }
  }, [resetField])

  return (
    <div className="flex flex-col gap-4">
      <FormField
        control={form.control}
        name="dockerImage"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Docker image</FormLabel>
            <FormControl>
              <Input
                autoComplete="off"
                placeholder="ghcr.io/linuxserver/nginx"
                aria-label="Docker image"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <Suspense fallback={<DockerImageInputFallback />}>
        <RegistrySelector />
      </Suspense>
    </div>
  )
}
